import { ACCOUNT } from "constants/tags";
import { apiService, currentVersion } from ".";
import { AccountLoginRequest, AccountLoginResponse, TProfile } from "../types/account";
import { ApiResponse } from "apis/types";

const url = `v${currentVersion}/account`;

const accountApi = apiService.injectEndpoints({
  endpoints: (build) => ({
    loginAccount: build.mutation<AccountLoginResponse, AccountLoginRequest>({
      query: (config) => ({
        method: "post",
        url: `${url}/login`,
        ...config,
      }),
    }),
    confirmEmail: build.mutation<ApiResponse<{ data: string }>, { code: string; userId: string }>({
      query: ({ code, userId }) => ({
        url: `${url}/confirm-email?code=${code}&userId=${userId}`,
      }),
    }),
    getProfile: build.query<ApiResponse<TProfile>, {}>({
      query: (config) => ({
        url: `${url}/profile`,
        ...config,
      }),
      providesTags: [ACCOUNT],
    }),
    changePassword: build.mutation<ApiResponse<{ data: string }>, {}>({
      query: (data) => ({
        method: "post",
        url: `${url}/change-password`,
        data,
      }),
    }),
    forgotPassword: build.mutation<ApiResponse<{ data: string }>, {}>({
      query: (data) => ({
        method: "post",
        url: `${url}/forgot-password`,
        data,
      }),
    }),
    resetPassword: build.mutation<ApiResponse<{ data: string }>, {}>({
      query: (data) => ({
        method: "post",
        url: `${url}/reset-password`,
        data,
      }),
    }),
  }),
});

export const accountService = accountApi;
export default accountApi;
